import React from "react";
import styles from "./ProfileSkeleton.module.css";

export const ProfileSkeleton = ({ isMobile }) => {
    return (
        <main className={styles.mainContent}>
            <div className={styles.header}>
                <div className={styles.bottomSection}>
                    {!isMobile && (
                        <div className={styles.inputColumn}>
                            <div className={styles.inputRow}>
                                <div className={styles.inputFieldWrapper}>
                                    <h1 className={styles.title}>Профиль</h1>
                                </div>
                            </div>
                        </div>
                    )}
                    <div className={styles.inputColumn}>
                        <div className={styles.inputRow}>
                            <div className={styles.inputFieldWrapper}>
                                <div className={styles.skeletonSaveButton}></div>
                            </div>
                        </div>
                        <div className={styles.checkIconWrapper}>
                            {/* Пустое место для галочки */}
                        </div>
                    </div>
                    <div className={styles.inputFile}>
                        <div style={{ width: "300px" }}></div>
                    </div>
                </div>
            </div>

            <div className={styles.bottomSection}>
                <div className={styles.inputColumn}>
                    {/* Левая колонка */}
                    {[...Array(7)].map((_, i) => (
                        <div key={`left-${i}`} className={styles.inputRow}>
                            <div className={styles.inputFieldWrapper}>
                                <div className={styles.skeletonInputField}></div>
                            </div>
                            <div className={styles.checkIconWrapper}></div>
                        </div>
                    ))}
                </div>

                <div className={styles.inputColumn}>
                    {/* Правая колонка */}
                    {[...Array(5)].map((_, i) => (
                        <div key={`right-${i}`} className={styles.inputRow}>
                            <div className={styles.inputFieldWrapper}>
                                <div className={styles.skeletonInputField}></div>
                            </div>
                            <div className={styles.checkIconWrapper}></div>
                        </div>
                    ))}

                    {/* Блок образования */}
                    <div className={styles.inputRow}>
                        <div className={styles.inputFieldWrapper}>
                            <div className={styles.educationHeader}>
                                <div className={styles.skeletonLabel}></div>
                                <div className={styles.skeletonAddButton}></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.inputFile}>
                    <div className={styles.skeletonPhoto}></div>
                </div>
            </div>
        </main>
    );
};